import { FC } from 'react'
import { strapiResponseInterface } from '@components/CMS/types'
import { blogSerializedType } from '@components/CMS/Blogs/types'
import { MDXRemote } from 'next-mdx-remote'
import MainLayout from '@components/MainLayout/MainLayout'
import dateFormat from 'dateformat'
import { useRouter } from 'next/router'

function ArrowLeftIcon(props: any) {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
      <path
        d="M7.25 11.25 3.75 8m0 0 3.5-3.25M3.75 8h8.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const Blog: FC<strapiResponseInterface<blogSerializedType>> = (props) => {
  const router = useRouter()
  const { title, publishedAt, heroImage, content } = props.data.attributes

  return (
    <MainLayout
      title="Blog Posts powered by BidFTA Online Auctions"
      previewDescription="Read about all of the tips and tricks to good deals on BidFTA Online Auctions with these recent blogs from the BidFTA insiders!"
    >
      <div className="pt-8 pb-32 bg-white mobile-padding">
        <div className="xl:relative">
          <div className="mx-auto max-w-2xl">
            <button
              type="button"
              onClick={() => router.push('/blog')}
              aria-label="Go back to blogs"
              className="group mb-8 flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-md shadow-zinc-800/5 ring-1 ring-zinc-900/5 transition"
            >
              <ArrowLeftIcon className="h-4 w-4 stroke-zinc-500 transition group-hover:stroke-zinc-700" />
            </button>
            <article>
              <header className="flex flex-col">
                <h1 className="mt-6 text-4xl font-bold tracking-tight text-zinc-800 sm:text-5xl">
                  {title}
                </h1>
                <img
                  src={
                    heroImage.data.attributes.formats.medium?.url ||
                    heroImage.data.attributes.url
                  }
                  alt={heroImage.data.attributes.alternativeText}
                  className="h-64 w-full rounded-2xl bg-gray-100 object-cover my-4"
                />
                <time
                  dateTime={publishedAt}
                  className="order-first flex items-center text-base text-zinc-400"
                >
                  <span className="h-4 w-0.5 rounded-full bg-zinc-200" />
                  <span className="ml-3">
                    {dateFormat(publishedAt, 'longDate')}
                  </span>
                </time>
              </header>
              <div className={'prose flex flex-wrap'}>
                <MDXRemote {...content} />
              </div>
            </article>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

export default Blog
